// Recovered compiled webpack factory 52894. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "formatNextPathnameInfo", {
      enumerable: !0,
      get: function () {
        return s;
      },
    }));
  let n = r(77700),
    a = r(73879),
    o = r(77886),
    i = r(6997);
  function s(e) {
    let t = (0, i.addLocale)(
      e.pathname,
      e.locale,
      e.buildId ? void 0 : e.defaultLocale,
      e.ignorePrefix,
    );
    return (
      (e.buildId || !e.trailingSlash) && (t = (0, n.removeTrailingSlash)(t)),
      e.buildId &&
        (t = (0, o.addPathSuffix)(
          (0, a.addPathPrefix)(t, "/_next/data/" + e.buildId),
          "/" === e.pathname ? "index.json" : ".json",
        )),
      (t = (0, a.addPathPrefix)(t, e.basePath)),
      !e.buildId && e.trailingSlash
        ? t.endsWith("/")
          ? t
          : (0, o.addPathSuffix)(t, "/")
        : (0, n.removeTrailingSlash)(t)
    );
  }
}
